import { QuestionTypes } from './enums'
import { QuestionData, SignatureData } from './types'

export default function isSignatureQuestion(value: QuestionData): value is QuestionData<SignatureData> {
  return value.type === QuestionTypes.SIGNATURE
}
